/* eslint-disable */
/**
 * 碰撞线索窗口消息通知
 */
import { commonApis } from '@/api';
import { Message, Notification as $notify } from 'element-ui';
import store from '../../../store';
import router from '../../../router';

// 使用桌面通知必须支持Notification API，并且允许通知（必须要https才能操作通知，http协议不允许通知）
let isNotification = window.Notification && window.Notification.permission === 'granted';
// 桌面通知实例
let notification = null;
// eslint-disable-next-line
let notifies = [];
let lastTotal = 0;
let currData = 0;
let isShow = false;

class Notify {
    constructor() {
        if (!Notify.instance) {
            Notify.instance = this;
        }
        return Notify.instance;
    }

    // 获取Notification桌面通知权限
    getNotificationPermission() {
        if (!Notification) return;
        // granted 用户允许通知，denied 用户不允许，default 用户目前还没有管你
        if (window.Notification.permission !== 'granted') {
            window.Notification.requestPermission()
                .then(() => {
                    isNotification = window.Notification && window.Notification.permission === 'granted';
                });
        }
    }

    // 获取消息提醒
    getNotification() {
        commonApis.getNotification()
            .then(({ data }) => {
                currData = data;
                if (lastTotal !== data) {
                    isShow = true;
                } else {
                    isShow = false;
                }

                if (typeof data === 'number' && data > 0 && isShow) {
                    // 关闭之前的弹窗
                    if (notifies.length) {
                        for (const item of notifies) {
                            item.close();
                        }
                    }
                    if (isNotification) this.openNotification(data);
                    else this.openPageNotify(data);
                } else if (data === 0) {
                    if (notifies.length) {
                        for (const item of notifies) {
                            item.close();
                        }
                    }
                }
                lastTotal = data;
            })
            .catch((err) => {
                throw new Error(err);
            });
    }

    // 打开Notification桌面通知
    openNotification(total) {
        let timer = null;
        const title = '【碰撞】';
        const content = `你有${total}条未处理的消息`;

        this.getNotificationPermission();

        if (window.Notification.permission === 'granted') {
            timer = setTimeout(() => {
                const notificationNow = new Notification(title, {
                    body: content,
                    renotify: true,
                    // 通知保持有效不自动关闭，默认为false。
                    requireInteraction: true,
                    tag: new Date(),
                });
                notification = notificationNow;

                // 五秒自动关闭
                // setTimeout(() => {
                //     notification.close();
                // }, 5000);
                const context = this;
                notification.onclick = () => {
                    // 让当前选项卡获取焦点
                    window.focus();
                    // 跳转到碰撞列表页面
                    context.routerToPage();
                    notification.close();
                };

                notification.onclose = () => {
                    if (!(lastTotal && currData)) context.closeNotification();
                };

                notifies.push(notification);
                clearTimeout(timer);
                timer = null;
            }, 100);
        }
    }

    // 无桌面通知权限，打开页面内通知
    openPageNotify(total) {
        let timer = null;
        const title = '【碰撞】';
        const content = `你有${total}条未处理的消息`;

        timer = setTimeout(() => {
            const notify = $notify({
                title,
                message: content,
                position: 'bottom-right',
                duration: 0,
                type: 'warning',
                onClick: () => {
                    // 点击跳转, 关闭弹窗
                    this.routerToPage();
                    notify.close();
                },

                onClose: () => {
                    if (!(lastTotal && currData)) this.closeNotification();
                },
            });
            notifies.push(notify);
            clearTimeout(timer);
            timer = null;
        }, 100);
    }

    // 点击关闭弹窗,不再通知
    async closeNotification() {
        try {
            await commonApis.closeNotification();
        } catch (err) {
            throw new Error(err);
        }
    }

    routerToPage() {
        const getAuthority = store.getters['user/getAuthority'];
        if (!getAuthority('CollisionList', 'Read')) {
            Message({
                type: 'warning',
                message: '暂未开通此模块权限，请联系凯励程运营',
            });
            return;
        }
        const { history: { current: { query: { navType } } } } = router;
        router.push({
            name: 'CollisionListIndex',
            query: {
                navType,
            },
        });
    }

    // 关闭notify
    removeNotify() {
        if (notifies.length) {
            for (const item of notifies) {
                item.close();
            }
        }
    }

    beforeunloadClose() {
        if (notification) notification.close();
    }
}

export default new Notify();
